import DOMPurify from 'dompurify';

// Any link that opens a new tab must not be able to reach back via window.opener
// (reverse tabnabbing), so force rel="noopener noreferrer" on target="_blank".
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

/**
 * Sanitize an HTML string before it is rendered with v-html.
 *
 * The consent texts and localized strings coming from the backend legitimately
 * contain markup (links, lists, bold text), so we do NOT escape it - we strip
 * only the dangerous parts (script tags, event handlers, javascript: URIs)
 * while keeping the safe HTML intact.
 *
 * @param {string} dirty raw HTML string
 * @returns {string} sanitized HTML safe for v-html
 */
export function sanitizeHtml(dirty) {
    if (dirty === null || dirty === undefined) {
        return '';
    }
    return DOMPurify.sanitize(String(dirty));
}

export default sanitizeHtml;
